import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faSearchDollar } from "@fortawesome/free-solid-svg-icons"
import moment from "moment"
import { COLORS } from "../../utilities/Constants"
import { generalStyles } from "../styles/styles"
import { complementAdresseToListString } from "../../utilities/Addons"
import {
	ENTITE_TYPE_PERSONNE_PHYSIQUE,
	ENTITE_TYPES_DICT,
} from "../dashboard/entite/Entite"
import { RefRow, RefSection } from "../others/RefCardV2"

// "2001-05-14" → "14.05.2001" ; vide si pas de date (RefRow masque la ligne).
const dateSuisse = (d) =>
	d ? moment(d, "YYYY-MM-DD").format("DD.MM.YYYY") : ""

/**
 * Carte de référence Client de la fiche location : lecture seule, texte —
 * même langage que la carte Client/Véhicule d'atelier. Reprend les rubriques
 * des anciennes PersonnePhysiqueCard/EntiteCard, permis compris (métier
 * location).
 *
 * - `entite` : form.entite ; `adresse` : complément d'adresse ou null.
 * - `onVoirClient` : callback d'ouverture de la fiche client, ou null si masqué.
 */
const LocationClientCardV2 = ({ entite, adresse, onVoirClient }) => (
	<div style={{ ...generalStyles.card, height: "100%" }}>
		<RefSection
			title="Client"
			action={
				<>
					{entite.is_mauvais_payeur && (
						<FontAwesomeIcon
							icon={faSearchDollar}
							title="Mauvais payeur"
							style={{ color: COLORS.danger }}
						/>
					)}
					{onVoirClient && (
						<button
							type="button"
							title="Voir le client"
							style={generalStyles.iconBtn(COLORS.text)}
							onClick={onVoirClient}
						>
							<FontAwesomeIcon icon={faEye} />
						</button>
					)}
				</>
			}
		>
			{entite.type === ENTITE_TYPE_PERSONNE_PHYSIQUE ? (
				<>
					<RefRow label="Nom" value={entite.nom} />
					<RefRow label="Prénom" value={entite.prenom} />
					<RefRow label="Tél" value={entite.telephone} />
					<RefRow label="E-mail" value={entite.email} />
				</>
			) : (
				<>
					<RefRow label="Nom" value={entite.label} />
					<RefRow
						label="Type"
						value={ENTITE_TYPES_DICT[entite.type]}
					/>
					<RefRow label="Tél" value={entite.telephone} />
					<RefRow label="E-mail" value={entite.email} />
				</>
			)}
			{adresse && (
				<RefRow
					label="Adresse"
					value={
						<>
							{complementAdresseToListString(adresse)[0]}
							<br />
							{complementAdresseToListString(adresse)[1]}
						</>
					}
				/>
			)}
			{entite.type === ENTITE_TYPE_PERSONNE_PHYSIQUE && (
				<>
					<RefRow
						label="Naissance"
						value={dateSuisse(entite.date_naissance)}
					/>
					<RefRow label="Permis" value={entite.permis} />
					<RefRow label="N° permis" value={entite.numero_permis} />
					<RefRow
						label="Obtenu le"
						value={dateSuisse(entite.date_obtention_permis)}
					/>
				</>
			)}
		</RefSection>
	</div>
)

export default LocationClientCardV2
